/** Words for a habit's choice rows (Habits UX pass 2026-09-06). Values unchanged; the engines read them. */
export const HABIT_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Whenever' },
  { value: 'medium', label: 'Normal' },
  { value: 'high', label: 'Important' },
]
import { formatDuration } from './dayShape'
// The same words the pages use for a duration ("1 hr 30 min"); the old label
// read "1.5h 30m" for ninety minutes.
export const DURATION_CHIPS = [5, 10, 15, 20, 30, 45, 60, 90].map((n) => ({ value: String(n), label: formatDuration(n) }))
